import script from "./GameGuideLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameGuideLinks.vue?vue&type=script&setup=true&lang=ts"

import "./GameGuideLinks.vue?vue&type=style&index=0&id=ec36fd82&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec36fd82"]])

export default __exports__